import React from 'react';

export const QuizLayout = ({ 
  currentStep, 
  totalSteps, 
  children, 
  onBack, 
  onContinue, 
  showBack = true,
  showContinue = true,
  showNavigation = true 
}) => {
  const progressPercentage = (currentStep / totalSteps) * 100;

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#ffffff' }}>
      {/* Header */}
      <header className="w-full">
        <div className="flex items-center justify-between px-6 py-4 max-w-4xl mx-auto w-full">
          {/* Step indicator */}
          <span className="text-sm font-sans" style={{ color: '#999' }}>
            {currentStep} / {totalSteps}
          </span>
          
          {/* Hashi-aid Logo */}
          <div className="flex items-center">
            <span className="text-2xl font-serif gradient-text tracking-tight">Hashi-aid</span>
          </div>
          
          {/* Spacer for balance */}
          <div className="w-12"></div>
        </div>
        
        {/* Progress bar */}
        <div className="w-full h-1 progress-track">
          <div 
            className="h-full progress-bar"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 flex flex-col items-center px-6 py-8 overflow-y-auto">
        <div className="w-full max-w-md mx-auto animate-fade-in">
          {children}
        </div>
      </main>

      {/* Footer navigation */}
      {showNavigation && (
        <footer className="w-full" style={{ borderTop: '1px solid #eee', backgroundColor: '#ffffff' }}>
          <div className="flex items-center justify-center gap-4 px-6 py-6 max-w-md mx-auto">
            {showBack && (
              <button 
                onClick={onBack}
                className="back-button"
              >
                Back
              </button>
            )}
            {showContinue && (
              <button 
                onClick={onContinue}
                className="continue-button min-w-[180px]"
              >
                Continue
              </button>
            )}
          </div>
        </footer>
      )}
    </div>
  );
};

export default QuizLayout;
